import type { ElementType } from 'react';
import type { StreamdownProps } from 'streamdown';

import { componentMappings as markdownComponentMappings } from '../../markdown/Markdown.js';

/** Streamdown's component map type */
type StreamdownComponents = NonNullable<StreamdownProps['components']>;

/**
 * Custom component mapping for Streamdown that extends the markdown mappings we have for react-markdown
 * with a code component that distinguishes between inline and block code and returns the appropriate type.
 */
export const streamdownComponents = {
  ...markdownComponentMappings,
  code: ({ children, node, ...restProps }) => {
    const isInline = node?.position?.start?.line === node?.position?.end?.line;
    const MarkdownCode = markdownComponentMappings.code as ElementType;

    return (
      <MarkdownCode inline={isInline} {...restProps}>
        {children}
      </MarkdownCode>
    );
  },
  // The markdownComponentMappings are typed for react-markdown, but they're compatible with
  // Streamdown so we can cast them here to avoid unnecessary duplication of the mapping logic.
} as StreamdownComponents;
